<template>
	<div class="nav">
		<div class="creditDisplay">
			<creditStatus />
		</div>
		<div class="userDisplay">
			<logNotifications />
			<el-tooltip content="Start Workflow Tour" placement="bottom" effect="dark">
				<div
					id="wf-tour-global-start-btn"
					class="topBarIcon"
					@click="showWorkflowTourIntro = true"
				>
					<svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<circle cx="12" cy="12" r="10" stroke="#374151" stroke-width="1.5" />
						<path d="M16.2426 7.75736L14.1213 14.1213L7.75736 16.2426L9.87868 9.87868L16.2426 7.75736Z" fill="#374151" fill-opacity="0.1" stroke="#374151" stroke-width="1.5" stroke-linejoin="round" />
					</svg>
				</div>
			</el-tooltip>
			<el-dialog
				title="Building Your First Automation"
				:visible.sync="showWorkflowTourIntro"
				width="560px"
				:close-on-click-modal="false"
				custom-class="premium-dialog"
			>
				<div class="tourIntroText">
					<p style="font-weight: 600; font-size: 17px; margin-bottom: 12px; color: #111827;">
						Welcome to Centiloquy.
					</p>
					We’re excited to help you automate your first business task. In this quick guide, 
					we’ll show you how to set up an automated email system step-by-step. 
					You’ll see how easy it is to save time and handle your daily work automatically.
				</div>
				<span slot="footer">
					<el-button @click="showWorkflowTourIntro = false">Cancel</el-button>
					<el-button type="primary" @click="confirmStartWorkflowTour">Start Tour</el-button>
				</span>
			</el-dialog>
			<el-tooltip content="User Guide" placement="bottom" effect="dark">
				<div id="wf-tour-docs-btn" class="topBarIcon" @click.prevent="openDocs">
					<img src="/userguide.svg" alt="Centiloquy User Guide" width="40px" />
				</div>
			</el-tooltip>
			<el-avatar
				:style="{
					backgroundColor: returnColor($cookies.get('username')),
					fontWeight: 'bold',
					fontSize: '18px',
				}"
			>
				{{ returnUsername }}
			</el-avatar>
			<div class="usernameDisplay">
				<p style="font-weight: bold">{{ $cookies.get("username") }}</p>
				<p style="font-size: 12px">{{ $cookies.get("orgName") }}</p>
			</div>
		</div>
	</div>
</template>

<script>
import { returnColor } from "../utils/general.js";
import creditStatus from "./creditStatus.vue";
import logNotifications from "./logNotifications.vue";
export default {
	components: {
		logNotifications,
		creditStatus,
	},
	computed: {
		returnUsername() {
			return this.$cookies.get("username")?.charAt(0)?.toUpperCase();
		},
	},
	data() {
		return {
			showWorkflowTourIntro: false,
		};
	},
	methods: {
		returnColor(string) {
			return returnColor(string);
		},
		openDocs() {
			const url = `${window.location.origin}/docs/`;
			window.open(url, "_blank");
		},
		startWorkflowTour() {
			localStorage.setItem("workflowTourStartRequested", "true");
			localStorage.setItem("workflowTourInProgress", "true");
			localStorage.setItem("workflowTourPhase", "list");
			localStorage.setItem("workflowTourManualStart", "true");

			if (this.$route.name !== "workflows") {
				this.$router.push("/workflows").catch(() => { });
			} else {
				window.dispatchEvent(new Event("workflow-tour-start"));
			}
		},
		confirmStartWorkflowTour() {
			this.showWorkflowTourIntro = false;
			this.startWorkflowTour();
		}
	},
};
</script>

<style scoped>
.nav {
	height: 69px;
	width: 100%;
	border-bottom: solid 1px #e9e9eb;
	display: flex;
}

.userDisplay {
	display: flex;
	align-items: center;
	margin-left: auto;
	margin-right: 40px;
	gap: 6px !important;
}

.creditDisplay {
	display: flex;
	align-items: center;
	margin-right: auto;
	margin-left: 40px;
}

.usernameDisplay {
	display: flex;
	flex-direction: column;
	margin-left: 5px;
}

.usernameDisplay p {
	margin-top: 2.5px;
	margin-bottom: 2.5px;
	text-align: left;
}

.tourIntroText {
	font-size: 15px;
	line-height: 1.6;
	color: #374151;
	word-break: normal;
	overflow-wrap: break-word;
	hyphens: none;
	text-align: left;
}

.topBarIcon {
	width: 40px;
	height: 40px;
	border: 1px solid #e9e9eb;
	border-radius: 6px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	background: white;
	transition: all 0.2s ease;
	margin-right: 10px;
}

.topBarIcon:hover {
	border-color: #d1d5db;
	background: #f9fafb;
}

.topBarIcon img,
.topBarIcon svg {
	display: block;
}
</style>
